<template>
	<div class="Index">
		<div class="search">
			<router-link :to="{path:'/personal/index'}" class="avatar">
				<img :src="userInfo.avatar" alt="">
			</router-link>
			<div class="search-input">
				<van-icon name="search" />
				<input type="text" placeholder="请输入搜索关键词" @focus="goSearch">
			</div>
			<div   class="attentiontBtn" @click="followChannel">{{followText}}</div>
		</div>
		<div class="swiper-img">
			<img :src="bannerImg" alt="">
		</div>
		<div class="articles">
			<div class="tabs">
				<div class="title-button active" v-for="(item,index) in channelsList" :key="index" @click="changeTab(index)">
					<img src="../../assets/images/regionButton.png" v-if="channel_id==69"/>
					<img src="../../assets/images/style2.png" v-if="channel_id==73"/>
					<p v-if="channel_id==69&&index==0">文献<span>威</span>读</p>
					<p v-else-if="channel_id==69&&index==1">研行<span>利</span>学</p>
					<p v-else-if="channel_id==69&&index==2">高<span>坦</span>阔论</p>
					<p v-else style="color:black;">{{item.name}}</p>
				</div>
			</div>
			<div class="content">
				<div class="list">
					<row-item-list :list="articlesList"></row-item-list>
				</div>
			</div>
		</div>
		<van-popup v-model="showForm" position="center" @close="closePop"  :close-on-click-overlay="closeOverlay" >
			<form-info :fieldArr="fieldArr" @func="changeInfoStatus"></form-info>
		</van-popup>
	</div>
</template>
<script>
	import Banner from "../../components/Banner.vue";
    import Tabbar from '../../components/Tabbar.vue';
    import RowItemList from "../../components/RowItemList.vue"
	import FormInfo from './FormInfo'
    import {InformationMenu,InformationDetails,PersoanalUserInfo,followChannels,followChannelsStatus,ColumnDetails,ColumnFollow,PersoanalAttention} from "../../config/interface.js"
	export default{
		components:{
			Banner,
    		Tabbar,
    		RowItemList,
			FormInfo
		},
		data(){
			return{
				closeOverlay:false,
				userInfo:{},     //用户信息
				isEmpty:false,   //列表数据是否为空
				bannerImg:'',    //轮播图
				followText:'关注',
				type:6,
				active:0,           //tabbar的index
				sonactive:0,        //title默认的index
				articlesList:[],   //文章列表
				columnsList:[],    //专栏列表
				rotateLoading:false,        //换一批的icon状态
				channelsList:[],           //频道列表
				channel_id:0,         //频道id
				sonChannel_id:0,      //子频道id
				swiperOption: {
					direction: 'horizontal',
	                loop: true,
	                autoplay: 3000,
	                slidesPerView: "auto",
	                centeredSlides:true,
	                spaceBetween: 10,
			        pagination: {
			            el: '.swiper-pagination',
			            clickable: true
			        }
        		},
				column_id:'',
				showForm:false,
				fieldArr:[],
			}
		},
		beforeRouteEnter(to, from, next) {
            //  修复iOS版微信HTML5 History兼容性问题
            if (to.path !== location.pathname) {
                //console.log("检测完成")
                // 此处不可使用location.replace
                location.assign(to.fullPath)
            } else {
                next()
            }
        },
		created(){
			this.channel_id=this.$route.query.id;
			this.column_id=this.$route.query.column_id;
			this.active=0;
			// document.title=language.CHANNEL_LIST[this.channel_id].title;
			this.getUserInfo();
			// this.channelDetail();
			// common.wxShare(document.title,language.CHANNEL_LIST[this.channel_id].desc,language.CHANNEL_LIST[this.channel_id].img);
		},
		mounted(){
		},
		watch:{
			    '$store.state.Loading':(newVal,oldVal)=>{
			      	this.loading=newVal;
			    }			
		},
		methods:{
			//频道状态
			checkChannelStatus(){
				const url=PersoanalAttention;
				let params={};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						data.columns.forEach((item,index)=>{
							if(item.id==this.column_id){
								this.followText='已关注';
							}
						})
					}
				})
			},
			//详情
			channelDetail(){
				const url=ColumnDetails;
				let params={
					id:this.channel_id
				}
				const method="POST"
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.bannerImg=res.data.image;
					}
				})
			},
			//获取用户信息
			getUserInfo(){
				const url=PersoanalUserInfo;
				let params={};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.userInfo=data;
						localStorage.setItem('userInfo',JSON.stringify(data));
           				this.$store.dispatch('storageUserInfo',data);
						if(this.userInfo.mobile){
							this.getChannels();
							this.checkChannelStatus();
							this.getForm();
						}	
						else{
							//未绑定
      						var callback_url=window.location.href;
      						window.location.href='/user/bindMobile?callback_url='+encodeURIComponent(callback_url);
						}
					}
				})
			},
			//表单
			getForm(){
				const url=InformationDetails;
				let params={
					channel_id:this.channel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						var data=res.data;
						if(data.has_form==1){
							this.showForm=true;
						}
						this.fieldArr=data.form_fields;
					}
				})
			},
			//频道目录
			getChannels(){
				const url=InformationMenu;
				let params={
					channel_id:this.channel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.channelsList=res.data;
						this.sonChannel_id=res.data[0].id;
						this.bannerImg=this.channelsList[0].image;
						// this.aloading=false;
						// this.showForm=res.data.has_form;
						this.getlist();
						// this.page=0;
						// this.onLoad(this.page);
					}
				})
			},
			//关注频道
			followChannel(){
				const url=ColumnFollow;
				let params={
					column_id:this.column_id
				}
				const method="POST";
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.followText=res.data.attach?'已关注':'关注';
					}
				})
				
			},
			//列表
			getlist(){
				const url=InformationDetails;
				let params={
					channel_id:this.sonChannel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						var data=res.data;
						this.articlesList=data.articles;
						this.isEmpty=data.articles.length==0?true:false;
						// let my_favorites=data.my_favorites;
						this.articlesList.forEach((item,index)=>{
							if(this.sonChannel_id!=72){
								if(this.channel_id==73&&item.start_at){
									this.$set(item,'release_at',item.start_at.substring(0,16));
									// this.$set(this.articlesList,index,item)
									// item.release_at=item.start_at.substring(0,20);
								}
								else{
									item.release_at=item.release_at==null?'':common.splitString(item.release_at,' ',0);
								}
							}
							else{
								if(item.start_at&&item.end_at){
									item.release_at=item.start_at.substring(0,16)+"-"+item.end_at.substring(11,16);
								}
								else{
									item.release_at=item.release_at==null?'':item.release_at;
								}
							}
							// this.$set(item,'isCollect',my_favorites[item.id]);
						})

					}
				})
			},
			//切换tab标签时触发
			changeTab(index,title){
				this.active=index;
				this.sonChannel_id=this.channelsList[index].id;
				this.bannerImg=this.channelsList[index].image;
				this.getlist();
				
			},
			//切换标题
			changeTitle(index,id){
				this.sonactive=index;
				this.sonChannel_id=id;
				this.getlist();
			},
			
			//去搜索
			goSearch(){
				this.$router.push({path:'search/search'})
			},
			//去选择城市
			selectCity(){
				this.$router.push({path:'/city/city'})
			},
			closePop(){
				this.showForm=false;
			},
			changeInfoStatus(data){
				this.showForm=data;
			},
			
		}
	}
</script>
<style lang="scss">
	.Index{
		//轮播
		.swiper-img{
			margin:0 auto;
			padding:0px 12px;
			/*width:350px;*/
			box-sizing:border-box;
			.van-swipe-item{
				img{
					width:100%;
					/*height:150px;*/
					border-radius:5px;
				}
			}
		}
		.test{
			margin: 0;

		}
		/*动画*/
		.rotate-active{
			animation: rotate-in 1s;
		}
		@keyframes rotate-in{
			0%{
				transform: rotate(0);
			}
			100%{
				transform: rotate(360deg);
			}
		}
		/*搜索*/
		.search{
			padding:8px 12px;
			@include flex(row);
			align-items:center;
			justify-content:space-between;
			.avatar{
				img{
					width:35px;
					height:35px;
					border-radius:100%;
				}

			}
			.search-input{
				@include flex(row);
				align-items:center;				
				flex:1;
				background: #F2F2F2;
				border: 1px solid #BFBFBF;
				border-radius: 16px;
				height:35px;
				padding:0px 5px;
				padding-left:10px;
				margin:0 8px;
				i{
					font-size:20px;
					color:#999;
				}
				input{
					flex:1;
					font-size:14px;
					color:#999;
					height:100%;
					padding-left:10px;
					background:transparent;
					border:0px;
				}
			}
			.attentiontBtn{
				width: 62px;
				height:35px;
				line-height:35px;
				font-size:14px;
				color:#fff;
				text-align: center;
				background: #FF504F;
				border-radius: 35px;
				border-radius: 35px;
			}
		}
		/*轮播图*/
		.swiper-img{
			img{
				border-radius:5px;
				width:100%;
				height:100%;
			}
		}
		.head{
			height:50px;
			line-height:50px;
			h3{
			font-size: 17px;
			color: #090909;
			letter-spacing: 0.6px;
			}	
		}
		.articles{
			.tabs{
				margin: 5px;
				display: flex;
				justify-content: space-evenly;
				.title-button{
					width: 32%;
					display: inline-block;
					text-align: center;
					font-size: 18px;
    				font-weight: 549;
    				letter-spacing: 0.08rem;
					// font-size: 22px;
					// line-height: 40px;
					// background: #a9a9a9;
					img{
						width: 50%;
					}
				}
				.title-button.active{
					// background: #00948C;
					// color: #014a94;
					color: #013b77;
					span{
						padding: 1px;
						color: white;
						background: #013b77;
						border-radius: 50%;
					}
				}

			}
			.content{
				width:94%;
				margin:18px auto;
				background: #FFFFFF;
				box-shadow: 0 0 9px 0 rgba(0,0,0,0.15);
				.titleWrap{
					position:relative;
					height:45px;
					line-height:45px;
					clear: both;
					div{
						float:left;
						width:56%;
						font-weight: bold;
    					letter-spacing: 1px;
						font-size:15px;
						text-align:center;
						background:#f4f4f4;
					}
					div.active{
						width:44%;
						background:#fff;
					}
					.uppertrian{
							position:absolute;
							left:50%;
							top:0;
							border-style: solid;
							border-color:transparent transparent #fff;
							border-width:45px;
							transform: translate(-75%,-50%);
    						z-index: 3;
						}
					div.active{
						background:#fff;
						color:#333	
					}
					
				}
				.list{
					height:410px;
					overflow: auto;
				}
			}
		}
		.van-overlay{
			display:block;
			z-index:100;
			.tip{
				width: 70%;
				position: absolute;
				right: 20px;
				top: 0;
			}
			.know{
				width:120px;
				position: absolute;
				bottom: 50px;
				left:50%;
				transform: translate(-50%,0);
				width:130px;
				
			}
		}
		.line-clamp-2{
			line-height: 0.5rem;
		}

	}
</style>


// WEBPACK FOOTER //
// src/pages/region/Index.vue